import { apiPost } from "@/lib/http/client";
import type { InvoiceSearchRequest, InvoiceSearchResponse } from "@/types/api";

export async function searchInvoices(body: InvoiceSearchRequest) {
  return apiPost<InvoiceSearchResponse>("/invoices/search", body);
}
